import companyGroupsSwiper from "../components/company-groups/company-groups-swiper/company-groups-swiper.js";
import popupVideo from "../components/UI/popup/popup-video/popup-video.js";
import menu from "../components/menu/menu.js";
import aboutCompanySwiper from "../components/about-company/about-company-swiper/about-company-swiper.js";
import tabs from "../components/UI/tabs/tabs.js";
import vendorsLine from "../components/vendors/vendors-line/vendors-line.js";
import footer from "../components/footer/footer.js";
import toggle from "../components/UI/toggle/toggle.js";

window.addEventListener('DOMContentLoaded', function () {
    menu();
    popupVideo();
    companyGroupsSwiper();
    aboutCompanySwiper()
    tabs();
    toggle();
    vendorsLine();
    footer();
});